import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { FirebaseAnalytics, FirebaseInitOptions } from '@capacitor-community/firebase-analytics';
import { TMMFirebaseAnalyticsEvent, TP8FirebaseAnalyticsEvent } from '@monorepo/types';

type TFirebaseAnalyticsEvent = TP8FirebaseAnalyticsEvent | TMMFirebaseAnalyticsEvent;

@Injectable({ providedIn: 'root' })
export class FirebaseAnalyticsService<AnalyticsEvent extends TFirebaseAnalyticsEvent> {
  async init(enableAnalytics: boolean, firebaseWebInitOptions?: FirebaseInitOptions, userId?: string) {
    if (!Capacitor.isNativePlatform() && firebaseWebInitOptions) {
      try {
        await FirebaseAnalytics.initializeFirebase(firebaseWebInitOptions);
        console.log('(firebase-analytics) Successfully initialized Firebase Analytics for web.');
      } catch (error) {
        console.error('[ERROR](firebase-analytics) Error initializing Firebase Analytics for web.', error);
      }
    }

    if (enableAnalytics) await this.enable();
    if (userId) await this.setUserId(userId);
  }

  async setUserId(userId: string) {
    try {
      await FirebaseAnalytics.setUserId({ userId });
    } catch (error) {
      console.error('[ERROR](firebase-analytics) Error setting user id.', error);
    }
  }

  async enable() {
    try {
      await FirebaseAnalytics.setCollectionEnabled({ enabled: true });
      console.log('(firebase-analytics) Successfully enabled Firebase Analytics.');
    } catch (error) {
      console.error('[ERROR](firebase-analytics) Error enabling Firebase Analytics.', error);
    }
  }

  async logEvent(ev: AnalyticsEvent) {
    try {
      await FirebaseAnalytics.logEvent({ name: ev.name, params: ev.params ?? {} } as any);
    } catch (error) {
      console.error('[ERROR](firebase-analytics) Error loggin Firebase event.', ev, error);
    }
  }

  async disable() {
    try {
      await FirebaseAnalytics.setCollectionEnabled({ enabled: false });
      console.log('(firebase-analytics) Successfully Disabled Firebase Analytics.');
    } catch (error) {
      console.error('[ERROR](firebase-analytics) Error disabling Firebase Analytics.', error);
    }
  }
}
